"use strict";

var _regeneratorRuntime = require("/tmp/build/80754af9/justo-repo/web/node_modules/babel-preset-orionsoft-react-app/node_modules/@babel/runtime/regenerator");

exports.__esModule = true;
exports.default = getResultPromise;

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var createPromise = function createPromise(observableQuery) {
  return new Promise( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
      var subscription;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              subscription = observableQuery.subscribe(function (nextResult) {
                if (!nextResult.loading) {
                  subscription.unsubscribe();
                  resolve();
                  observableQuery.resultPromise = null;
                }
              });

            case 1:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, this);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
};

function getResultPromise(observableQuery) {
  if (observableQuery.resultPromise) return observableQuery.resultPromise;
  observableQuery.resultPromise = createPromise(observableQuery);
  return observableQuery.resultPromise;
}